import React from "react";

const ViewFromFileUpload = ({ index, title, answer, setAnswer, type }) => {
  const handleOnChange = (event) => {
    const files = Object.values(event.target.files);
    const filesData = {};

    files.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const { name } = file;
        const base64Value = reader.result;
        filesData[name] = base64Value;
      };
    });

    setAnswer(index, filesData);
  };

  return (
    <div className="form-group">
      <label className="mr-3">{title}</label>
      <input
        type={type}
        multiple
        onChange={(event) => handleOnChange(event)}
      ></input>
    </div>
  );
};

export default ViewFromFileUpload;
